/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import SimpleCrypto from 'simple-crypto-js'
import url from '@/services/ApiServices/apiUrls'
import router from '@/router/index'
import { store } from '@/store/store'
import { authenticationApi } from './authenticationApi'
import { agentApis } from './agentApis'

export const vendorApis = new Vue({
	methods: {
		async vendorLogin (loginData) {
			const _secretKey = 'password'
			const simpleCrypto = new SimpleCrypto(_secretKey)
			if (store.getters['user/isAuthenticated']) {
				await authenticationApi.logOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.vendorLoginUrl, loginData)
					.then((res) => {
						store.dispatch('vendor/setVendorAuthenticated', true)
						store.dispatch('vendor/setStatusData', res.data)
						if (res.data.request_status === true) {
							router.push('/vendorGst')
						} else {
							router.push('/vendorPlan')
						}
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 412) {
							const objectpw = loginData.password
							const objectun = loginData.username
							const encryptedpw = simpleCrypto.encrypt(objectpw)
							const encryptedun = simpleCrypto.encrypt(objectun)
							router.push({
								path: '/ExistingVendorSignup',
								query: {
									encryptun: encryptedun,
									encryptpw: encryptedpw
								}
							})
						}
						if (e.status === 400) {
							router.push('/pages/vendorSignup')
						}
						Vue.toasted.show(`${e.data.message}`)
						reject(e)
					})
			})
		},
		async createVendorRequest (user) {
			if (store.getters['user/isAuthenticated']) {
				await authenticationApi.logOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.vendorRequest, user)
					.then((res) => {
						store.dispatch('vendor/setVendorAuthenticated', true)
						Vue.toasted.show('Your Vendor Request Successfully Registered.', { position: 'top-center' })
						// vendorApis.vendorLogin({
						//   username: user.email,
						//   password: user.password,
						// });
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 400) {
							// const productInfo = user.product_info
							router.push('/ExistingVendorSignup')
						}
						if (e.status === 412) {
							router.push('/vendorLogin')
						}
						Vue.toasted.show(e.data.message, { icon: 'exclamation-circle' })
						reject(e)
					})
			})
		},
		getVendorPlan () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.vendorPlans)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		subscriptionPlan (planId) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.subscriptionPlanUrl, { plan_id: planId })
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		subscriptionCreate (planId) {
			const countryCode = store.getters['siteData/getSelectedCountry'].country_code
			return new Promise((resolve, reject) => {
				this.$http.post(url.subscriptionCreateUrl, {
					plan_id: planId,
					country_code: countryCode
				})
					.then((res) => {
						store.dispatch('vendor/setSubscriptionOrderData', res.data)
						store.dispatch('user/setOrderData', res.data)
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		subscriptionPayment (paymentId, subscriptionId) {
			const postUrl = `${url.subscriptionPaymentUrl}${paymentId}&subscription_id=${subscriptionId}`
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		vendorAccountInformation (accountData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.vendorAccountInformationUrl, accountData)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		vendorLogOut () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.vendorSignOutUrl)
					.then((res) => {
						store.dispatch('vendor/setVendorAuthenticated', false)
						if (router.currentRoute.matched.some(record => record.meta.requiresVendorAuth)) {
							router.push({
								path: '/vendorLogin'
							})
						}
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		serverImageUpload (documentpath) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.vendorDocumentUploadUrl, documentpath)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		async vendorSignUp (clientData) {
			const vendorSignUpSuccess = () => {
				store.dispatch('vendor/setVendorAuthenticated', true)
				store.dispatch('vendor/setStatusData', { request_status: 'REQUEST PROCESSING' })
				Vue.toasted.show('Your Vendor Request Successfully Registered.', { position: 'top-center' })
				setTimeout(() => {
					router.push('/vendorPlan')
				}, 100)
			}
			const postUrl = url.vendorRequest
			if (store.getters['user/isAuthenticated']) {
				await authenticationApi.logOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl, clientData)
					.then((res) => {
						vendorSignUpSuccess()
						resolve(res)
					})
					.catch((e) => {
						// if (e.status === 400) {
						//   const productInfo = user.product_info;
						//   router.push('/ExistingVendorSignup');
						// }
						reject(e)
					})
			})
		},
		// vendorOrAgentSignUp
		agentSignUp (clientData) {
			const agentSignUpSuccess = () => {
				// store.dispatch('vendor/setVendorAuthenticated', true);
				Vue.toasted.show('Your Agent Request Successfully Registered.', { position: 'top-center' })
				router.push({
					name: 'AgentDashBoard'
				})
			}
			const postUrl = url.agentSignUpRequest
			if (store.getters['user/isAuthenticated']) {
				authenticationApi.logOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl, clientData)
					.then((res) => {
						agentSignUpSuccess()
						resolve(res)
					})
					.catch((e) => {
						// if (e.status === 400) {
						//   const productInfo = user.product_info;
						//   router.push('/ExistingVendorSignup');
						// }
						reject(e)
					})
			})
		},
		vendorInfo () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.vendorInfoUrl)
					.then((res) => {
						store.dispatch('vendor/setVendorData', res.data)
						if (res.data.request_status !== null) {
							store.dispatch('vendor/setStatusData', { request_status: res.data.request_status })
						}
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		vendorOrderListInfo () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.vendorOrderListInfoUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		vendorRequestOtp (vendorEmail) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.vendorRequestOtpUrl, vendorEmail)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		async vendorLoginViaOtp (otp) {
			if (store.getters['user/isAuthenticated']) {
				await authenticationApi.logOut()
			} else if (store.getters['agent/isAgentAuthenticated']) {
				await agentApis.agentLogOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.vendorLoginOtpUrl, otp)
					.then((res) => {
						store.dispatch('vendor/setVendorAuthenticated', true)
						store.dispatch('vendor/setStatusData', res.data)
						if (res.data.payment_status === true) {
							router.push('/pages/vendordashboard')
						} else {
							router.push('/vendorPlan')
						}
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show(`${e.data.message}`)
						reject(e)
					})
			})
		},
		async newVendorLogin (loginData, checkData) {
			if (store.getters['user/isAuthenticated']) {
				await authenticationApi.logOut()
			} else if (store.getters['agent/isAgentAuthenticated']) {
				await agentApis.agentLogOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.vendorLoginUrl, loginData)
					.then((res) => {
						store.dispatch('vendor/setVendorAuthenticated', true)
						store.dispatch('vendor/setStatusData', res.data)
						if (res.data.payment_status === true) {
							router.push('/pages/vendordashboard')
						} else {
							if (checkData === 'existingCustomer') {
								$('#SignupModal').modal('hide')
							}
							router.push('/vendorPlan')
						}
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 403 && e.data.message === 'Bad credentials') {
							Vue.toasted.show('Password you entered is wrong')
						} else {
							Vue.toasted.show(`${e.data.message}`)
						}
						reject(e)
					})
			})
		},
		vendorInfoUpdate (updatedData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.updateVendorInfoUrl, updatedData)
					.then((res) => {
						Vue.toasted.show('Vendor Info Updated Successfully.', { position: 'top-center' })
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show(`${e.data.message}`)
						reject(e)
					})
			})
		}
	}
})
